// import smoothscroll for Smooth Scroll behavior on Safari
import smoothscroll from 'smoothscroll-polyfill';

// GSAP (GreenSock Animation Platform)
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
//
// gsap.registerPlugin(ScrollTrigger);
// window.gsap = gsap;

document.addEventListener("DOMContentLoaded", () => {
    // init smoothscroll
    smoothscroll.polyfill();

    // Custom progress bar and add header class on scroll

    window.addEventListener("scroll", progressBar);
    let header = document.querySelector('header');

    function progressBar() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 100;
        document.getElementById("progressBar").style.width = scrolled + "%";
        if (window.pageYOffset < 50 && header.classList.contains('scroll')) {
            header.classList.remove('scroll');
        }
        if (window.pageYOffset >= 50 && !header.classList.contains('scroll')) {
            header.classList.add('scroll');
        }
    }

    const mobileToggle = document.querySelector('.menu-toggle');
    const menu = document.querySelector('nav');
    const links = document.querySelectorAll('nav a');

    function toggleMobileMenu() {
        mobileToggle.classList.toggle('active');
        menu.classList.toggle('active');
        document.body.classList.toggle('overflow-hidden-mobile');
    }

    mobileToggle.addEventListener('click', toggleMobileMenu);
    links.forEach(el => el.addEventListener('click', toggleMobileMenu));


    // Impressum & Datenschutz opening on click

    let privacyLink = document.querySelectorAll('.imprint');

    const openBlock = (element) => {
        let block = document.querySelector(element.getAttribute('href'));
        let menuHeight_compensetion = document.querySelectorAll('header')[0].clientHeight;

        if (!block.classList.contains('d-none')) {
            let anchorBlock = document.querySelector('footer');
            let elementPosition = anchorBlock.offsetTop;
            let offsetPosition = elementPosition + anchorBlock.clientHeight - document.documentElement.clientHeight;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            setTimeout(() => {
                block.classList.add('d-none');
            }, 1000)
        } else {
            block.classList.remove('d-none');
            let anchorBlock = block;
            let headerOffset = menuHeight_compensetion;
            let elementPosition = anchorBlock.offsetTop;
            let offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }

    privacyLink.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openBlock(e.target);
        })
    });
});